import styles from '../businessProcess/businessProcess.module.css';
import {
  businessProcessSwimlanes,
  type BusinessProcessSwimlane,
} from '../businessProcess/definitions';
import type WhiteboardController from '../controllers/WhiteboardController';
import { svgToIcon } from '../utils/svg';
import Stylus from './Stylus';
import SwimlaneDrawingBrush from './SwimlaneDrawingBrush';

interface StylusSwimlaneArgs {
  controller: WhiteboardController;
  id: string;
}

class StylusSwimlane extends Stylus {
  swimlane: BusinessProcessSwimlane;

  constructor({ controller, id }: StylusSwimlaneArgs) {
    super({ controller });

    const swimlane = businessProcessSwimlanes.find(s => s.id === id);
    if (!swimlane) {
      throw new Error(`Swimlane with id ${id} not found`);
    }
    this.swimlane = swimlane;
  }

  activate() {
    const brush = new SwimlaneDrawingBrush(
      this.controller.canvas,
      this,
      this.swimlane.options
    );
    this.controller.canvas.isDrawingMode = true;
    this.controller.canvas.freeDrawingBrush = brush;
  }

  stylusId() {
    return `swimlane-${this.swimlane.id}`;
  }

  toolButtonClass() {
    return styles.businessProcessLargeButton;
  }

  description() {
    return this.swimlane.name ?? '';
  }

  renderIcon() {
    return svgToIcon(this.swimlane.icon);
  }
}

export default StylusSwimlane;
